import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '@bo-client/core/api/api';
import { UpdatePasswordDto } from '@bo-client/shared/models/updatePasswordDto';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RegexToCheckPassword } from '@bo-client/shared/forms/forms.validators';
import { ValidatorsService } from '@bo-client/shared/forms/validators.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit, OnDestroy {
  model: UpdatePasswordDto = {};
  passwordFormGroup: FormGroup;

  private compUnsubs$ = new Subject<void>();
  public hideCurrentPW = true;
  public hideNewPW = true;
  public isLoading = false;
  public error: string;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    public matDialog: MatDialog,
    public dataShareService: DataShareService,
    public dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    private validatorsService: ValidatorsService
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.passwordFormGroup = this.formBuilder.group({
      currentPassword: [null, [Validators.required]],
      password: [null, [Validators.required, Validators.pattern(RegexToCheckPassword)]]
    });
  }

  close() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.isLoading = true;

    this.model.newPassword = this.passwordFormGroup.get('password').value;
    this.model.oldPassword = this.passwordFormGroup.get('currentPassword').value;

    this.userService
      .updatePassword(this.model)
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe(
        (result) => {
          if (result) {
            this.isLoading = false;
            this.dialogRef.close(true);
          } else {
            this.isLoading = false;
            this.error = 'Das aktuelle Passwort ist falsch.';
          }
        },
        (error) => {
          this.isLoading = false;
          this.error = 'Beim Ändern des Passworts ist ein Fehler aufgetreten.';
        }
      );
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
